import React from 'react';
import PropTypes from 'prop-types';
import StarRating from '../ui/StarRating';

const ReviewCard = ({ reviewer, date, rating, comment, avatarUrl }) => {
  return (
    <div className="w-full h-[251px] bg-gray-50 rounded-[12px] p-[24px] flex flex-col gap-[16px]">
      <div className="flex items-center gap-3">
        <div className="w-[48px] h-[48px] rounded-full overflow-hidden">
          <img 
            src={avatarUrl} 
            alt={reviewer} 
            className="w-full h-full object-cover"
            onError={(e) => {
              e.target.onerror = null;
              e.target.style.display = 'none';
            }}
          />
        </div>
        <div>
          <h4 className="font-medium text-gray-800">{reviewer}</h4>
          <p className="text-sm text-gray-500">{date}</p>
        </div>
      </div>
      <StarRating rating={rating} />
      <p className="text-gray-600">"{comment}"</p>
    </div>
  );
};

ReviewCard.propTypes = {
  reviewer: PropTypes.string.isRequired,
  date: PropTypes.string.isRequired,
  rating: PropTypes.number.isRequired,
  comment: PropTypes.string.isRequired,
  avatarUrl: PropTypes.string.isRequired
};

export default ReviewCard;
